export const GAME_TOP_UP_EVENT = 'bb:game-top-up';
export const GAME_TOP_UP_CLOSE_EVENT = 'bb:game-top-up-close';
export const isGameRoute = (pathname: string): boolean =>
  /^\/game\/[^/]+$/.test(pathname) || /^\/path\/game\/\d+$/.test(pathname);

export const openGameTopUp = (detail: { returnTo?: 'artifacts' } = {}): void => {
  window.dispatchEvent(new CustomEvent(GAME_TOP_UP_EVENT, { detail }));
};

export const gameCheckpointStorage = {
  getItem(key: string): string | null {
    // The tab copy can be newer when persistent storage hit its quota.
    try {
      const value = sessionStorage.getItem(key);
      if (value !== null) return value;
    } catch {
      /* Independent fallback. */
    }
    try {
      return localStorage.getItem(key);
    } catch {
      return null;
    }
  },
  setItem(key: string, value: string): void {
    try {
      localStorage.setItem(key, value);
    } catch {
      /* Preserve the previous durable copy if the new write cannot fit. */
    }
    try {
      sessionStorage.setItem(key, value);
    } catch {
      /* Keep the live game usable. */
    }
  },
  removeItem(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch {
      /* Optional storage. */
    }
    try {
      sessionStorage.removeItem(key);
    } catch {
      /* Optional storage. */
    }
  },
};

/** Retain newer local moves only when they extend the server checkpoint. */
export const resumeActionLog = <T>(
  server: readonly T[] | undefined,
  local: unknown,
): readonly T[] => {
  if (!Array.isArray(local)) return server ?? [];
  if (
    !server ||
    (local.length >= server.length &&
      JSON.stringify(local.slice(0, server.length)) === JSON.stringify(server))
  )
    return local as T[];
  return server;
};

/** Preserve a rejected local journal before falling back to the server checkpoint. */
export const preserveRunJournal = (key: string): boolean => {
  const value = gameCheckpointStorage.getItem(key);
  if (value === null) return true;
  const archive = `${key}:recovery:${Date.now()}`;
  gameCheckpointStorage.setItem(archive, value);
  return gameCheckpointStorage.getItem(archive) === value;
};
